export enum OfficeServiceEnum {
  outlook,
  generic
}
